import { render, staticRenderFns } from "./OP_ModSummary.vue?vue&type=template&id=624d5158&scoped=true&"
import script from "./OP_ModSummary.vue?vue&type=script&lang=js&"
export * from "./OP_ModSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624d5158",
  null
  
)

export default component.exports